import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { IMaskInput } from "react-imask";

/**
 * MoneyMaskedInputBase
 */

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const MoneyMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});

/**
 * MoneyMaskedInput
 */

type Props = {
  name: string,
  label: string,
  error?: boolean,
  helperText?: string,
  readOnly?: boolean,
  value?: string,
  onChange: (value: string) => void,
};

export const MoneyMaskedInput = ({
  name,
  label,
  error,
  helperText,
  value,
  readOnly = false,
  onChange,
}: Props) => {

  const [newValue, setNewValue] = useState('');

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setNewValue(event.target.value);
    onChange(event.target.value);
  }, [onChange]);

  useEffect(() => {
    if (value) {
      setNewValue(value)
    }
  }, [value])

  return (
    <FormControl variant="outlined" size="small" fullWidth={true}>
      <InputLabel htmlFor={`input-${name}`} shrink={true} size="small" error={error}>{label}</InputLabel>
      <OutlinedInput
        size="small"
        id={`input-${name}`}
        name={name}
        value={newValue}
        label={label}
        notched={true}
        readOnly={readOnly}
        error={error}
        fullWidth={true}
        aria-describedby={`${name}-component-error-text`}
        onChange={handleChange}
        inputComponent={MoneyMaskedInputBase as any}
        inputProps={{
          mask: [
            { mask: 'R$ \\0,\\00' },
            { mask: 'R$ \\0,00' },
            { mask: 'R$ 0,00' },
            { mask: 'R$ 00,00' },
            { mask: 'R$ 000,00' },
            { mask: 'R$ 0.000,00' },
            { mask: 'R$ 00.000,00' },
            { mask: 'R$ 000.000,00' },
            { mask: 'R$ 0.000.000,00' },
            { mask: 'R$ 00.000.000,00' },
            { mask: 'R$ 000.000.000,00' },
          ],
          placeholder: "R$ ___.___.___,__",
        }} />
      <FormHelperText id={`${name}-component-error-text`} error={true}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}